export default class PreviewLoginBanner {
  static hide(){
    let banner = document.querySelector('.preview-login-banner');

    if(banner){
      banner.classList.add('hide');
    }
  }

  static show(){
    let banner = document.querySelector('.preview-login-banner');

    if(banner){
      banner.classList.remove('hide');
    }
  }
}
